<template>
  <div class="inithomework">
    <div class="back"></div>
    <div class="main">
      <div class="main_inner">
        <left-panel-student :userid="userid" :studentsList="contentsList" @changeStudent="changeStudent"></left-panel-student>
        <div class="right-content">
          <div class="chat-area">
            <chat-top :title="title"></chat-top>
            <scroll-wrapper :question="question" :reply="reply"></scroll-wrapper>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import leftPanelStudent from '@/components/homework/leftpanelWithStudent'
  import chatTop from '@/components/homework/scheckchattop'
  import scrollWrapper from '@/components/homework/scheckwrapper'
  export default {
    data() {
      return {
        id: (() => loadLocal('id', false))(),
        title:'',
        rid:'',
        lessonid:'',
        classid:'',
        homeworkid:'',
        question:[],
        reply: [],
        contentsList:[],
        userid:'',       //当前学生的userid
      }
    },
    methods: {
      isEmpty(obj){
        for (let i in obj) {
          return !1;
        }
        return !0;
      },
      changeStudent(userid){
        this.userid=userid;
        this.isFirstSent = true;
        this.contentsList.forEach((ele)=>{
          if(ele.userid===userid){
            this.reply=this.transform(ele.reply);
            this.temp=[];
          }
        })
      },
      QueryHomeWorkContent(classid, homeworkid) {
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'HomeWork',
            a: 'QueryHomeWorkContent',
            id: this.id,
            classid: classid,
            homeworkid: homeworkid
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {

            this.userid=response.userid;
            let list = response.list[0];
            this.contentsList=list.content;
            this.question = this.transform(list.question);
            list.content.forEach((ele)=>{
              if(ele.userid==userid){
                this.reply = this.transform(ele.reply)
              }
            })
            this.$forceUpdate();
            this.$forceUpdate();
          }
        }).catch((err) => {

        });
      },
      transform(list){
        try {
          JSON.parse(decodeURIComponent(list))
          return JSON.parse(decodeURIComponent(list))
        }
        catch(err) {
          return []
        }
      },
      quitEdit(){
        this.$router.replace('/console/homework/undone')
      },
      computeUpList(list){
        if (this.isEmpty(list)) {
          return '';
        } else {
          let result = JSON.stringify(list);
          result = encodeURIComponent(result);
          return result;
        }
      }
    },
    created() {
      this.title = decodeURIComponent(this.$utils.getUrlKey('title'));
      this.classid = decodeURIComponent(this.$utils.getUrlKey('classid'));
      this.rid = decodeURIComponent(this.$utils.getUrlKey('rid'));
      this.lessonid = decodeURIComponent(this.$utils.getUrlKey('lessonid'));
      this.homeworkid = decodeURIComponent(this.$utils.getUrlKey('homeworkid'));

      if (this.homeworkid != 'null') {
        this.QueryHomeWorkContent(this.classid, this.homeworkid)
      }
    },
    components:{
      leftPanelStudent,
      chatTop,
      scrollWrapper,
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .inithomework {
    height: 100%;
    .back {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: url('./background.png') no-repeat 50%;
      background-size: cover;
    }
  }

  .main {
    height: 80%;
    min-height: 600px;
    padding-top: 100px;
    -webkit-transition: padding .3s linear;
    .main_inner {
      max-width: 1000px;
      min-width: 800px;
      height: 100%;
      margin: 0 auto;
      border-radius: 3px;
      overflow: hidden;
      background: #fff
      .right-content {
        height: 100%;
        .chat-area {
          position: relative;
          height: 100%;
          overflow: hidden;
        }
      }
    }
  }

  @media (max-height: 800px), (max-width: 1000px) {
    .main {
      padding-top: 0;
      height: 100%;
    }
  }
  .hint-mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    background: rgba(0, 0, 0, 0.3)
    z-index: 1000
    font-size: 0
    &::after {
      content: "";
      display: inline-block;
      height: 100%;
      width: 0;
      vertical-align: middle;
    }
    .sendhint {
      display: inline-block;
      padding: 40px 0 0;
      width: 400px;
      height: 290px;
      vertical-align: middle;
      background-color: #fff;
      border-radius: 6px;
      overflow: hidden;
      box-sizing: border-box
      .img-wrapper {
        margin-bottom: 20px;
        height: 50px;
        text-align: center
      }
      .send-title {
        font-size: 16px;
        color: #333;
        height: 22px;
        line-height: 22px;
        margin-bottom: 10px;
      }
      .hint-text {
        margin: 0 70px 20px;
        font-size: 14px;
        color: #a5a5a5;
        line-height: 22px;
      }
      .back-btn {
        display: inline-block;
        font-size: 15px;
        color: #fff;
        width: 250px;
        height: 36px;
        line-height: 36px;
        background: #3399ff;
        border-radius: 4px;
        &:hover {
          background: #5eaefe
        }
      }
      .cancel, .confirm {
        display: inline-block;
        width: 106px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        font-size: 15px;
        color: #fff;
        border-radius: 4px;
      }
      .cancel {
        margin-right: 20px;
        background: #ccc;
      }
      .confirm {
        background: #3399ff;
        &:hover {
          background: #5eaefe
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/homework/scomplete/scomplete.vue